import index from './home.js'
import common from './common.js'
import contact from './contact.js'
import abount from './abount.js'
import subsidiaries from './subsidiaries.js'
import factory from './factory.js'
import services from './services.js'
import footer from './footer.js'
import support from './support.js'
import products from './products.js'
import careers from './careers.js'
import catalogues from './catalogues.js'
import faq from './faq.js'
import guides from './guides.js'
import account from './account.js'

export default {
  index,
  common,
  support,
  products,
  careers,
  catalogues,
  guides,
  account,
  contact,
  abount,
  subsidiaries,
  factory,
  services,
  footer,
  support,
  faq
};
